import { useState, useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { layoutActions } from '../store';
import {
  FormControl, InputLabel, Select, MenuItem, Button, TextField, Grid, Typography, Box, Modal, Snackbar, makeStyles, Divider, ButtonBase
} from '@material-ui/core';
import { api_call, console_log, empty, get_data_value } from '../helpers/untils';
import PhotoCameraIcon from '@material-ui/icons/PhotoCamera';
import CloseIcon from '@material-ui/icons/Close';
import Lightbox from 'react-image-lightbox';

const modalStyle = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '96%',
  maxWidth: '400px',
  bgcolor: 'background.paper',
  boxShadow: 24,
  p: 3,
};

const useStyles = makeStyles(() => ({
  buttons: {
    display: 'flex',
    justifyContent: 'space-evenly',
    '& > *': {
      flexBasis: '33%',
    },
  },
  formContainer: {
    display: 'block',
    width: '100%',
  }
}));

const UserMaintDoneModal = (props) => {
  const dispatch = useDispatch();
  const user = useSelector((state) => state.session.user);
  const { open, setOpen, history, maintItem, deviceItem, onSuccess, showToast } = props;
  const handleModalClose = () => {
    setOpen(false)
  }
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [toastMessage, setToastMessage] = useState("");

  useEffect(() => {
    if (open) {
      dispatch(layoutActions.closeDeviceListMenu());
    }
  }, [open]);

  //////////////////////////////////////////////////////////////////
  const [apiLoading, setApiLoading] = useState(false);

  const defaultFormData = {}
  const [formData, setFormData] = useState(defaultFormData)

  const onChangeText = (e) => {
    const val = e.target.value
    const field_name = e.target.name
    console_log(`field_name::::`, field_name)
    const form_data = { ...formData }
    form_data[field_name] = val
    setFormData({ ...form_data })
  }

  const fileRef = useRef();
  const onClickFileBtn = () => {
    fileRef.current.click();
  }
  const [uploadFile, setUploadFile] = useState(null);
  const [image, setImage] = useState("")
  const [imageModalOpen, setImageModalOpen] = useState(false)
  const [currentImage, setCurrentImage] = useState("")

  const onFileInputChanged = (e) => {
    setUploadFile(e.target.files[0]);
    let files = e.target.files;
    console_log(files);
    if (!empty(files)) {
      setImage(URL.createObjectURL(files[0]))
    } else {
      setImage("")
    }
  }

  const resetForm = () => {
    setFormData(defaultFormData)
    setImage("")
    setUploadFile(null)
    fileRef.current.value = ""
  }

  const onClickAddPl = async () => {
    const url = `/api/device-pl/save-pl-data`;
    const form_data = new FormData();
    form_data.append('type', 'expense')
    form_data.append("deviceId", deviceItem.id);

    if (formData['tripId']) {
      form_data.append("tripId", formData['tripId']);
    }
    if (formData['amount']) {
      form_data.append("amount", formData['amount']);
    } else {
      window.alert("Cost is empty");
      return false
    }
    if (formData['note']) {
      form_data.append("note", formData['note']);
    }

    if (uploadFile) {
      form_data.append("upload_file", uploadFile);
    }

    setApiLoading(true)
    let response = await api_call(url, {
      method: 'POST',
      body: form_data,
    });
    setApiLoading(false)

    if (response.ok) {
      const apiData = await response.json();
      resetForm();
      handleModalClose();
      onSuccess();
    } else {
      const apiError = response;
      const errorMsg = apiError?.message || apiError?.error || "Error occurred while saving data";
      showToast(errorMsg);
    }
  }

  ////////////////////// app modal close feature //////////////////////////////////////////
  const appModalCloseTimestamp = useSelector((state) => state.layout.appModalCloseTimestamp);
  useEffect(() => {
    if (appModalCloseTimestamp) {
      setOpen(false)
    }
  }, [appModalCloseTimestamp]);
  /////////////////////////////////////////////////////////////////////////////////////////
  return (
    <>
      <Modal
        open={open}
        onClose={handleModalClose}
        aria-labelledby="parent-modal-title"
        aria-describedby="parent-modal-description"
      >
        <Box sx={modalStyle}>
          <Snackbar
            anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
            open={snackbarOpen}
            onClose={() => { setSnackbarOpen(false) }}
            autoHideDuration={1500}
            message={toastMessage}
          />
          <Typography id="modal-modal-title" variant="h6" component="h2">Expense P&L</Typography>
          <Box sx={{ paddingTop: 32 }}>
            <Box>
              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <FormControl variant="filled" fullWidth>
                    <InputLabel shrink>Cost</InputLabel>
                    <TextField
                      variant="filled"
                      label=""
                      type="number"
                      name="amount"
                      placeholder=""
                      value={get_data_value(formData, 'amount')}
                      onChange={(e) => onChangeText(e)}
                      fullWidth
                    />
                  </FormControl>
                </Grid>
                <Grid item xs={12}>
                  <FormControl variant="filled" fullWidth>
                    <InputLabel shrink>Notes</InputLabel>
                    <TextField
                      variant="filled"
                      label=""
                      type="text"
                      name="note"
                      placeholder=""
                      value={get_data_value(formData, 'note')}
                      onChange={(e) => onChangeText(e)}
                      fullWidth
                    />
                  </FormControl>
                </Grid>
                <Grid item xs={12}>
                  <FormControl variant="filled" fullWidth>
                    <InputLabel shrink><span style={{ visibility: 'hidden' }}>H</span></InputLabel>
                    <Box sx={{ pt: 1 }}>
                      <ButtonBase disableRipple={true} onClick={() => onClickFileBtn()}>
                        <PhotoCameraIcon fontSize="large" />
                      </ButtonBase>
                      <div className='hidden d-none'>
                        <input
                          ref={fileRef}
                          type="file"
                          name="upload_file"
                          className="file-upload-default upload_file"
                          accept="image/png, image/gif, image/jpeg"
                          onChange={(e) => onFileInputChanged(e)}
                        />
                      </div>
                    </Box>
                  </FormControl>
                </Grid>
                <Grid item xs={12}>
                  <FormControl variant="filled" fullWidth>
                    <InputLabel shrink><span style={{ visibility: 'hidden' }}>H</span></InputLabel>
                    <Box sx={{ pt: 0 }}>
                      <Button type="button" color="primary" variant="contained" size="small" disabled={apiLoading} fullWidth onClick={() => onClickAddPl()}>Save</Button>
                    </Box>
                  </FormControl>
                </Grid>
              </Grid>
            </Box>
          </Box>
        </Box>
      </Modal>

      {imageModalOpen && (
        <Lightbox
          mainSrc={currentImage}
          onCloseRequest={() => setImageModalOpen(false)}
        />
      )}

    </>
  );
};

export default UserMaintDoneModal;
